import _ from 'underscore'

import Cart from './Cart'
import Currency from './Currency'

class CartDomClass {
    constructor() {
        this.url = '/shop/cart/'
    }

    getItem(item, isAmountError=false) {
        return `<div class="cart__row${ isAmountError ? ` cart__row_error` : `` }" data-id="${ item.ID }" data-product-id="${ item.PRODUCT_ID }">
            <div class="cart__row_columns">
                <div class="cart__td cart__td_image">
                    <a href="${ item.DETAIL_PAGE_URL }" class="cart__image-link" style="background-image: url('${ item.PREVIEW_PICTURE }');"></a>
                </div>
                <div class="cart__td cart__td_name">
                    <a href="${ item.DETAIL_PAGE_URL }" class="cart__name-link">${ item.NAME }</a>
                </div>
                <div class="cart__td cart__td_price">
                    ${ (parseInt(item.DISCOUNT_PERCENT) === 100) ? `
                        <div class="cart__td-discount-percent">
                            Подарок
                        </div>
                    ` : `
                        ${ item.PRICE_FORMAT }
                        
                        ${ (item.DISCOUNT_PRICE > 0) ? `
                            <div class="cart__td-discount-price">
                                ${ item.BASE_PRICE_FORMAT }
                            </div>

                            <div class="cart__td-discount-percent">
                                Скидка -${ parseInt(item.DISCOUNT_PERCENT) }%
                            </div>
                        ` : `` }
                    ` }
                </div>
                <div class="cart__td cart__td_quantity">
                    ${ (parseInt(item.DISCOUNT_PERCENT) !== 100) ? `
                        <div class="input-number">
                            <span class="input-number__increment input-number__increment_minus">-</span>
                            <input type="text" value="${ item.QUANTITY }" class="input-number__count" />
                            <span class="input-number__increment input-number__increment_plus">+</span>
                        </div>
                    ` : `` }
                </div>
                <div class="cart__td cart__td_summary">
                    ${ (parseInt(item.DISCOUNT_PERCENT) !== 100) ? `
                        ${ item.SUMMARY_FORMAT }
                    ` : `` }
                </div>
                <div class="cart__td cart__td_actions">
                    <button class="cart__td-remove"></button>
                </div>
            </div>
            ${ isAmountError ? `<div class="cart__error-amount">
                <button class="cart__error-close"></button>
        
                <div class="cart__error-amount-title">
                    Количество товара в корзине превышает наличие на складе. В корзине был произведен автоматический перерасчёт!
                </div>
        
                <div class="cart__error-amount-notice">
                    Пожалуйста перепроверьте свой заказ.
                </div>
            </div>` : `` }
        </div>`
    }

    getGift(gift) {
        return `<div class="cart__row cart__row_columns cart__row_columns cart__row_columns-gift" data-product-id="${ gift.ID }">
            <div class="cart__td cart__td_image">
                <a href="${ gift.DETAIL_PAGE_URL }" class="cart__image-link" style="background-image: url('${ gift.PREVIEW_PICTURE }');"></a>
            </div>
            <div class="cart__td cart__td_name">
                <a href="${ gift.DETAIL_PAGE_URL }" class="cart__name-link">${ gift.NAME }</a>
            </div>
            <div class="cart__td cart__td_price">
                <div class="cart__td-discount-percent">
                    Подарок
                </div>
            </div>
            <div class="cart__td cart__td_add_gift">
                <button class="button button_buy button-add-gift" data-id="${ gift.ID }">Выбрать этот подарок</button>
            </div>
        </div>`
    }

    checkAmount(cb) {
        Cart.getItems((err, items) => {
            if (err) {

            } else {
                const updateProductIDs = {}

                items.forEach((item) => {
                    if (item.AMOUNT < item.QUANTITY) {
                        updateProductIDs[item.PRODUCT_ID] = item.AMOUNT
                    }
                })

                if (Object.keys(updateProductIDs).length > 0) {
                    Cart.updateAmounts(updateProductIDs, (err2, res) => {
                        if (err2) {
                            
                        } else {
                            if (cb) cb(updateProductIDs)
                        }
                    })
                } else {
                    if (cb) cb(updateProductIDs)
                }
            }
        })
    }

    setCartInfo(count_format, summary_format, discount_summary, discount_summary_format) {
        const summaryContainer = document.querySelector('.cart__summary-total-value'),
        discountSummaryContainer = document.querySelector('.cart__summary-discount-value'),
        countTitle = document.querySelector('.cart__title-count')

        if (summaryContainer && discountSummaryContainer && countTitle) {
            summaryContainer.innerHTML = summary_format
            discountSummaryContainer.innerHTML = discount_summary_format
            countTitle.innerHTML = count_format

            if (Math.abs(discount_summary) > 0) {
                discountSummaryContainer.parentNode.classList.remove('cart__hide')
            } else {
                discountSummaryContainer.parentNode.classList.add('cart__hide')
            }
        }
    }

    reset(isSetLoading=true) {
        const cartContainer = document.querySelector('.cart'),
        container = document.querySelector('.cart__body')

        if (container) {
            if (isSetLoading) cartContainer.classList.add('cart_loading')

            this.checkAmount((updateProductIDs) => {
                Cart.getCart((err, res) => {
                    if (err) {
                        
                    } else {
                        let content = res.items.reduce((r, item) => {
                            r += this.getItem(item, !!updateProductIDs[item.PRODUCT_ID])

                            return r
                        }, '')

                        Cart.getGifts((errGifts, gifts) => {
                            if (err) {
                                cartContainer.classList.remove('cart_loading')
                            } else {
                                content += gifts.reduce((r, item) => {
                                    r += this.getGift(item)
            
                                    return r
                                }, '')

                                container.innerHTML = content

                                this.setCartInfo(res.count_format, res.summary_format, res.discount_summary, res.discount_summary_format)
                                
                                cartContainer.classList.remove('cart_loading')

                                this.bindEvents({
                                    items : true,
                                    inputNumbers : true,
                                    gifts : true,
                                    amountErrors: true,
                                })
                            }
                        })
                    }
                })
            })
        }
    }
    
    bindEvents(segments = { items: false, inputNumbers: false, coupons: false, gifts: false, amountErrors: false }) {
        const cartContainer = document.querySelector('.cart')

        const throttleReset = _.throttle((id, value) => {
            cartContainer.classList.add('cart_loading')

            Cart.change(id, value, () => {
                this.reset()
            })
        }, 300, {
            leading: false
        })

        if (segments.items) {
            document.querySelectorAll('.cart .cart__td-remove').forEach((cartItem) => {
                cartItem.addEventListener('click', (e) => {
                    const parent = e.target.parentNode.parentNode.parentNode,
                    id = parseInt(parent.getAttribute('data-id'))
        
                    cartContainer.classList.add('cart_loading')

                    Cart.remove(id, () => {
                        this.reset(false)
                    })
                })
            })
        }

        if (segments.inputNumbers) {
            document.querySelectorAll('.cart .input-number .input-number__increment').forEach((inputNumberItem) => {
                inputNumberItem.parentNode.parentNode.querySelector('.input-number__count').addEventListener('change', (e) => {
                    const target = e.target,
                    parent = target.parentNode.parentNode.parentNode.parentNode,
                    id = parseInt(parent.getAttribute('data-id'))

                    let value = parseInt(target.value)

                    if (value <= 0 || !value) {
                        value = 1
                    }

                    target.value = value

                    cartContainer.classList.add('cart_loading')

                    Cart.change(id, value, () => {
                        this.reset(false)
                    })
                })

                inputNumberItem.addEventListener('click', (e) => {
                    const target = e.target,
                    inputNumber = target.parentNode.parentNode.querySelector('.input-number__count'),
                    parent = target.parentNode.parentNode.parentNode.parentNode,
                    id = parseInt(parent.getAttribute('data-id'))
                    
                    let value = parseInt(inputNumber.value)

                    if (target.classList.contains('input-number__increment_plus')) {
                        value++
                    } else if (target.classList.contains('input-number__increment_minus'))  {
                        value--
                    }

                    if (value <= 0) {
                        value = 1
                    }

                    inputNumber.value = value

                    throttleReset.cancel()
                    throttleReset(id, value)
                })
            })
        }

        if (segments.coupons) {
            const formCoupon = document.querySelector('.form_cart-coupon')
            
            if (formCoupon) {
                formCoupon.addEventListener('submit', (e) => {
                    e.preventDefault()

                    const code = document.querySelector('.cart__coupon-code').value.trim()

                    cartContainer.classList.add('cart_loading')

                    Cart.setCoupon(code, (err, res) => {
                        this.reset(false)
                    })

                    return false
                })
            }
        }

        if (segments.gifts) {
            document.querySelectorAll('.button-add-gift').forEach((giftItem) => {
                giftItem.addEventListener('click', (e) => {
                    const target = e.target,
                    productID = parseInt(target.getAttribute('data-id'))

                    cartContainer.classList.add('cart_loading')

                    Cart.add(productID, 1, (err, res) => {
                        this.reset(false)
                    })
                })
            })
        }

        if (segments.amountErrors) {
            document.querySelectorAll('.cart__error-amount').forEach((errorNode) => {
                const itemContainer = errorNode.parentNode.parentNode

                errorNode.querySelector('.cart__error-close').addEventListener('click', () => {
                    errorNode.remove()
                    itemContainer.classList.remove('cart__row_error')
                })
            })
        }
    }
}

const CartDom = new CartDomClass()

export default CartDom